import React, { Component } from 'react'
import './Addticket.css'
import { ExcelRenderer } from 'react-excel-renderer';
import { Modal } from 'react-bootstrap'
import UploadIcon from '@mui/icons-material/Upload';
import DownloadIcon from '@mui/icons-material/Download';
import Switch from '@material-ui/core/Switch';
import { Spinner } from 'react-bootstrap'
import { Table } from 'react-bootstrap'
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import moment from 'moment'
import Empmodal from '../../components/empmodal/Empmodal';
import axios from 'axios';
import Categorypic from '../../components/categorypiker/Categorypic';
import TimeFormatter from '../../utility/TimeFormatter';
import GetImage from '../../components/getimage/Getimage';
import { DatePicker } from '../../components/calendar/Calender';
import { showCustomSwal } from '../../components/customswal/Customswal';
import Empmodalbody from '../../components/empmodal/Empmodalbody';
import TATModalBody from '../../components/tatmodal/Tatmodal';
import { showConfirm } from '../../utility/showconfirm';
import Hexapi from '../../utility/HexAPI/Hexapi';
import TooltipButton from '../../components/tooltip/Popover';
import Tatdate from '../../components/Tatdate';
import Inputbox from '../../components/formcontrols/normal/InputBox';
import Textbox from '../../components/formcontrols/normal/Texbox';
import MyModalBody from '../../components/subcompsActivityModal/MyModalBody';
import withRouter from '../../utility/withRouter';
import { IoCloseOutline } from "react-icons/io5";
import Loader from '../../components/loader/Loader';


 class Addticket extends Component {
    constructor(props) {
        super(props);
        const getAllocatedToEmpID = (search) => {
            const urlParams = new URLSearchParams(search);
            const id = urlParams.get('TicketAllocatedid')
            if (id) {
                return id
            } else {
                return '-1'
            }
        }
        const getCheckedByEmpID = (search,props) => {
            const urlParams = new URLSearchParams(search);
            const id = urlParams.get('TicketAllocatedid')
            if (id) {
                return props?.userid
            } else {
                return '-1'
            }
        }

        this.state = {
     
            excelDownloadUrl: `https://web.trackhrapp.com/GenerateExcelNewv2.php`,
            userid: this.props?.userid,
            colors: this.props?.colors,
            isOpencategorymodal: true,
            Description: '',
            categoryIDSelected: '',
            formdata: {
                allocatedtoempids: [`${getAllocatedToEmpID(window.location.search)}`],
                allocatedtoempnames: [''],
                checkedbyempids: [`${getCheckedByEmpID(window.location.search,props)}`],
                checkedbyempnames: [''],
                remarks: [''],
                predefinedTat: ['-1'],
                predefinedTATStr: [''],
                isPredefinedTATSelected: [false],
                locationOnAction: [false],
                dueDate: [`${moment(new Date()).format('YYYY-MM-DD HH:mm:ss')}`],
                dueDateStr: [''],
                isDueDateSelected: [false]
            },
            alertNow: false,
            isEditMode: false,
            editRowId: '',
            editRowData: {},
            isParallel: false,
            renderAgain: false,
            defaultStage: 0,
            stageModalCheckedbylabelColor: 'black',
            storeAllocatedToEmpName: [],
            allocatedtoempID: getAllocatedToEmpID(window.location.search), CheckedByEmpList: [],
            storeCheckedByEmpName: [], checkedbyempID: getCheckedByEmpID(window.location.search), AllocatedToEmpList: [],
            isOpenAllocatedempmodal: false,isobserverModal:false,
            isOpenCheckedempmodal: false, storeRemarksValue: [], isOpenTATmodal: false,
            originalTATVAlue: [0], isTATselected: false, storeTATValue: ['-1'], isLocationSelected: [false],
            isAlertnow: false, storeduedate: [], originalduedate: [new Date()], isloadcompleted: true,
            descriptionColor: 'black', allocatedToEmpLabelColor: 'black', checkedByEmpLabelColor: 'black',
            isAddStageModalOpen: false, allocatedToEmpLabelColorInStage: 'black', checkedByEmpLabelColorInStage: 'black',
            isMultipleStage: false,stageModalallocatedlabelColor:"black",
            stageheaders: ['Stage', 'Allocated To', 'Checked By', 'Predefined TAT', 'Remarks','Due Date', 'Action'],
            tableArr: [],
            setFocus: false,
            observerEmpIdslist:'-1',
            categoryColor:false,

        }
        this.Addticket = this.Addticket.bind(this)
        this.fetchUserList = this.fetchUserList.bind(this)
        this.storeAlerNow = this.storeAlerNow.bind(this)
        this.openDueDateModal = this.openDueDateModal.bind(this)
        this.closeStageModal = this.closeStageModal.bind(this)
        this.storeRemarksValue = this.storeRemarksValue.bind(this)
        this.getTATvalue = this.getTATvalue.bind(this)
        this.OpenTATModal = this.OpenTATModal.bind(this)
        this.storeLocations = this.storeLocations.bind(this)
        this.onAddStageSuccess = this.onAddStageSuccess.bind(this)
        this.getHeader = this.getHeader.bind(this)
        this.removeTableRow = this.removeTableRow.bind(this)
        this.onEditRow = this.onEditRow.bind(this)
        this.closeEditModal = this.closeEditModal.bind(this)
        this.convertExcelDate=this.convertExcelDate.bind(this)
        this.CloseTATModal=this.CloseTATModal.bind(this)
    }
    scrollToMyRef = () => {
        if (document.getElementsByClassName("table-responsive")) {
            const scrollHeight = document.getElementsByClassName('table-responsive')[0].scrollHeight;
            const clientHeight = document.getElementsByClassName('table-responsive')[0].clientHeight;
            const scroll = scrollHeight - clientHeight
            document.getElementsByClassName('table-responsive')[0].scrollTo(0, scroll);
        }
    }
    selectedEmployees(empids, empnames) {
        console.log(empids, empnames)
        if (empids.length > 0 && empnames.length > 0) {
            this.setState({ isobserverModal: false, observerEmpIdslist: empids.join(','), observerEmpnamelist: empnames.join(',') })
        } else {
            this.setState({ isobserverModal: false, observerEmpIdslist: '-1', observerEmpnamelist: '' })

        }
        setTimeout(() => {
            console.log(this.state.observerEmpIdslist,this.state.observerEmpnamelist)
        }, 200);
    }
    getHeader(headers) {
        return headers.map((head) => {
            return (
                <th key={head} style={{ textAlign: "left" }}>{head}</th>
            )
        })
    }
    onEditRow(i) {
        console.log()
        this.setState({
            editRowData:{},
            editRowId:null
        },()=>{
            let obj = {}
   for (const key in this.state.formdata) {
            obj[key] = this.state.formdata[key][i]
        }
        this.setState({ editRowData: obj, isAddStageModalOpen: true, isEditMode: true, editRowId: i })
        })

    }
    closeEditModal() {
        this.setState({ isAddStageModalOpen: false, isEditMode: false })
    }
    componentDidUpdate(prevprops){
if(prevprops.userid !== this.props.userid){

}
    }
    componentDidMount() {
       
            let data = { header: 'Open Ticket' }
            let event = new CustomEvent('myCustomEvent', { detail: data })
            window.parent.document.dispatchEvent(event)

        
        if(!this.props.userid) return
            this.fetchUserList()
    }
    fetchUserList() {

        const obj={
        query :`[HRApp_Droid_Proc_AddTicket_GetFormData] @UserID='{0}' `,
        queryArr :[`${this.props.userid}`]
        }
       Hexapi(obj).then(resp => {
            console.log(resp.observer)
            if (resp && resp["checkedby"] && resp["checkedby"].length > 0) {
          const filledbyOptions = resp.checkedby.map((filledby) => ({
            value: filledby.empid,
            label: `${filledby.firstname} ${filledby.lastname}`,
          }));
        this.setState({
               CheckedByEmpList:filledbyOptions,
        })
        } else {
                this.setState({
               CheckedByEmpList:[],
        })
        }
         if (resp && resp["allocatedto"] && resp["allocatedto"].length > 0) {
          const filledbyOptions = resp.allocatedto.map((filledby) => ({
            value: filledby.empid,
            label: `${filledby.firstname} ${filledby.lastname}`,
          }));
        this.setState({
               AllocatedToEmpList:filledbyOptions,
        })
        } else {
                this.setState({
               CheckedByEmpList:[],
        })
        }

         const filledbyobserverOptions = resp.observer.map((filledby) => ({
            value: filledby.empid,
            label: `${filledby.firstname} ${filledby.lastname}`,
          }));
            this.setState({
                observerEmplist:filledbyobserverOptions,
            })


            this.setState({ renderAgain: true })
        }).catch(err => console.log('Employee fetch user details fetching Error in Store procedure [​​HRApp_Droid_Proc_AddTicket_GetFormData]: ', console.error(err)))
    }
    getAllocuserid(id, AllocatedToEmpName, closemodal) {
        this.setState({ setFocus: false })
        if (!this.state.isEditMode) {
            let { allocatedtoempids, allocatedtoempnames } = this.state.formdata
            allocatedtoempids[this.state.defaultStage] = id
            allocatedtoempnames[this.state.defaultStage] = AllocatedToEmpName

            this.setState({
                isOpenAllocatedempmodal: closemodal,
                allocatedToEmpLabelColor: 'black',
                renderAgain: true
            })
        } else {
            this.state.editRowData.allocatedtoempids = id
            this.state.editRowData.allocatedtoempnames = AllocatedToEmpName
            this.setState({
                isOpenAllocatedempmodal: closemodal,
                allocatedToEmpLabelColor: 'black',
                renderAgain: true
            })
        }

    }
    getCheckuserid(id, CheckedByEmpName, closemodal) {
        this.setState({ setFocus: false })
        if (!this.state.isEditMode) {
            let { checkedbyempids, checkedbyempnames } = this.state.formdata
            checkedbyempids[this.state.defaultStage] = id
            checkedbyempnames[this.state.defaultStage] = CheckedByEmpName

            this.setState({
                isOpenCheckedempmodal: closemodal, checkedByEmpLabelColor: 'black', renderAgain: true
            })
        } else {
            this.state.editRowData.checkedbyempids = id
            this.state.editRowData.checkedbyempnames = CheckedByEmpName

            this.setState({
                isOpenCheckedempmodal: closemodal, checkedByEmpLabelColor: 'black', renderAgain: true
            })
        }
    }
    getCategoryID(categoryID) {
        if(categoryID){

        } this.setState({
            categoryIDSelected: categoryID, isOpencategorymodal: false, setFocus: false,
            categoryColor:""
        })

    }
    getTATvalue(tat, str) {
        if (!this.state.isEditMode) {
            let { predefinedTat, predefinedTATStr } = this.state.formdata
            predefinedTat[this.state.defaultStage] = Number(tat)
            if (str == '') {
                predefinedTATStr[this.state.defaultStage] = '00:00 Hrs'
            } else {
                predefinedTATStr[this.state.defaultStage] = str
            }

            this.setState({
                renderAgain: true,
                isTATselected: true, isOpenTATmodal: false
            })
        } else {
            this.state.editRowData.predefinedTat = Number(tat)
            if (str == '') {
                this.state.editRowData.predefinedTATStr = '00:00 Hrs'
            } else {
                this.state.editRowData.predefinedTATStr = str
            }

            this.setState({
                renderAgain: true,
                isTATselected: true, isOpenTATmodal: false
            })
        }
    }

    getDueDate(date) {
        if (!this.state.isEditMode) {
            let dateObj = TimeFormatter(date)
            let { dueDate, dueDateStr } = this.state.formdata
            let str = `${dateObj.userSplitedDate[3]}, ${dateObj.userSplitedDate[2]} ${dateObj.shiftFullMonth} , ${dateObj.userSplitedDate[0]}`
            dueDate[this.state.defaultStage] = date
            dueDateStr[this.state.defaultStage] = str
            this.setState({ renderAgain: true, isOpenDueDateModal: false })
        } else {
            let dateObj = TimeFormatter(date)
            let str = `${dateObj.userSplitedDate[3]}, ${dateObj.userSplitedDate[2]} ${dateObj.shiftFullMonth} , ${dateObj.userSplitedDate[0]}`
            let { dueDate, dueDateStr } = this.state.formdata
            dueDate[this.state.defaultStage] = date
            dueDateStr[this.state.defaultStage] = str
            this.state.editRowData.dueDate = date
            this.state.editRowData.dueDateStr= str

            this.setState({
                renderAgain: true,
                isDueDateSelected: true, isOpenDueDateModal: false
            })
        }
        }

   async Addticket(e) {
        e.preventDefault();
        
        let isApiCanHit = true

        let {
            allocatedtoempnames, checkedbyempnames, allocatedtoempids, checkedbyempids,
            remarks, predefinedTat, locationOnAction,
            dueDate, isDueDateSelected
        } = this.state.formdata

        if (this.state.isMultipleStage == true) {
            if (this.state.Description == "") {
                isApiCanHit = false
                this.setState({ descriptionColor: 'red' })
            } else {
                this.setState({ descriptionColor: 'black' })
            }

            if (isApiCanHit) {
                this.setState({ isloadcompleted: false })
                let description = this.state.Description
                let categoryid = this.state.categoryIDSelected
                let userid = this.state.userid
                let Allocatedtoempids = allocatedtoempids.join('$1*2$$$')
                let Checkedbyempids = checkedbyempids.join('$1*2$$$')
                let Remarks = remarks.join('$1*2$$$')
                let TATs = predefinedTat.join('$1*2$$$')
                console.log(predefinedTat,"predefinedTat")
                console.log(TATs,"TATs")
                let DueDates = dueDate.join('$1*2$$$')
                let GPSs = locationOnAction.join('$1*2$$$').replaceAll('false', '0').replaceAll('true', '1')
                let parallelStage = this.state.isParallel ? '1' : '0'
                let Alert = (this.state.alertNow == true) ? "1" : "0"

             const obj={
                query:`HRApp_Droid_Proc_AddTicket_Linked_SubmitV4 @Description='{0}',@CategoryID='{1}',@UserID='{2}',@AllocatedToEmpIDs='{3}',@CheckedByEmpIDs='{4}',@Remarks='{5}',@TATs='{6}',@GPSonActionsList='{7}',@ParallelStage='{8}',@DueDates='{9}',@AlertNow='{10}',@ObserverEmpIDs='{11}'`,
                queryArr:[`${description}`,`${categoryid}`,`${userid}`,`${Allocatedtoempids}`,`${Checkedbyempids}`,`${Remarks}`,`${TATs}`,`${GPSs}`,`${parallelStage}`,`${DueDates}`,`${Alert}`,`${this.state.observerEmpIdslist}`]
             }
           const resp= await Hexapi(obj)

await showConfirm({
  content: resp[''][0].msg,
  hideCancel: true,
}).then(() => {
                        if (resp[''][0].command != "0") {
                                //  localStorage.setItem("activityid", this.props.ticketid);
//   localStorage.setItem("lastactiontype", 1);
 
  
        this.props.navigate(-1)
    
                        }
                    })


            }
        } else {
            if (this.state.Description == "") {
                isApiCanHit = false
                this.setState({ descriptionColor: 'red' })
            } else {
                this.setState({ descriptionColor: 'black' })
            }
            if (this.state.categoryIDSelected == "") {
                isApiCanHit = false
                this.setState({ categoryColor: 'red' })
            } else {
                this.setState({ categoryColor: 'black' })
            }

            if (allocatedtoempnames[0] == '') {
                isApiCanHit = false
                this.setState({ allocatedToEmpLabelColor: 'red' })
            } else {
                this.setState({ allocatedToEmpLabelColor: 'black' })
            }

            if (checkedbyempnames[0] == '') {
                isApiCanHit = false
                this.setState({ checkedByEmpLabelColor: 'red' })
            } else {
                this.setState({ checkedByEmpLabelColor: 'black' })
            }

            if (isApiCanHit) {
                this.setState({ isloadcompleted: false })
                var GPS = (locationOnAction[0] == true) ? "1" : "0"
                var Alert = (this.state.alertNow == true) ? "1" : "0"
                console.log(this.state)
                console.log(GPS, Alert)
                var TAT = predefinedTat[0]
                var duedate = isDueDateSelected[0] ? dueDate[0] : '-1'

               const obj={
                 query : "[HRApp_Droid_Proc_AddTicket_SubmitV4] @Description='{0}',@CategoryID='{1}',@UserID ='{2}',@AllocatedTo ='{3}',@CheckedBy ='{4}',@TAT ='{5}',@Remarks ='{6}',@GPSOnActions='{7}',@DueDate ='{8}',@AlertNow ='{9}',@ObserverEmpIDs='{10}'",
                queryArr : [`${this.state.Description}`, `${this.state.categoryIDSelected}`, `${this.state.userid}`, `${allocatedtoempids[0]}`, `${checkedbyempids[0]}`, `${TAT}`, `${remarks[0]}`, `${GPS}`, `${duedate}`, `${Alert}`,`${this.state.observerEmpIdslist}`]
               }
                Hexapi(obj).then(async(resp) => {
                    console.log(resp)
                   await showConfirm({
  content: resp[''][0].msg,
  hideCancel: true,
}).then(() => {
                        if (resp[''][0].command != "0") {
                            this.props.navigate(-1)
                        }
                    })
                }).then(resp => this.setState({ isloadcompleted: true })).catch(err => console.error('Error of ' +  + ' : ' + err + ' with url => (' +  + ')'))
            }
        }
    }
    AddStages(e) {
        e.preventDefault()
        let {checkedbyempnames, allocatedtoempnames } = this.state.formdata
        let isAddStage = true
        if (this.state.Description == "") {
            isAddStage = false
            this.setState({ descriptionColor: 'red' })
        }

        if (checkedbyempnames[this.state.defaultStage] == "") {
            isAddStage = false
            this.setState({ checkedByEmpLabelColor: 'red' })
        }

        if (allocatedtoempnames[this.state.defaultStage] == "") {
            isAddStage = false
            this.setState({ allocatedToEmpLabelColor: 'red' })
        }

        if (isAddStage) {
            this.setState({ isEditMode: false })
            let {
                allocatedtoempnames, checkedbyempnames, allocatedtoempids, checkedbyempids,
                remarks, predefinedTat, predefinedTATStr, isPredefinedTATSelected, locationOnAction,
                dueDate, dueDateStr, isDueDateSelected
            } = this.state.formdata
            let newDefaultStage = this.state.defaultStage + 1
            // allocatedtoempnames[newDefaultStage] = checkedbyempnames[newDefaultStage - 1]
            allocatedtoempnames[newDefaultStage] =''
            allocatedtoempids[newDefaultStage] = '-1'
            // allocatedtoempids[newDefaultStage] = checkedbyempids[newDefaultStage - 1]
            checkedbyempids[newDefaultStage] = '-1'
            checkedbyempnames[newDefaultStage] = ''
            remarks[newDefaultStage] = ''
            predefinedTat[newDefaultStage] = '-1'
            predefinedTATStr[newDefaultStage] = ''
            isPredefinedTATSelected[newDefaultStage] = false
            locationOnAction[newDefaultStage] = false
            dueDate[newDefaultStage] = `${moment(new Date()).format('YYYY-MM-DD HH:mm:ss')}`
            dueDateStr[newDefaultStage] = ''
            isDueDateSelected[newDefaultStage] = false
            this.setState({ renderAgain: true, isMultipleStage: true, isAddStageModalOpen: true, defaultStage: newDefaultStage })
            if (newDefaultStage - 1 == 0) {
                let newArr = []
                for (let i = 0; i < newDefaultStage; i++) {
                    let obj = {
                        allocatedtoempname: allocatedtoempnames[i],
                        allocatedtoempid: allocatedtoempids[i],
                        checkedbyempname: checkedbyempnames[i],
                        checkedbyempid: checkedbyempids[i],
                        predefinedTATstr: predefinedTATStr[i],
                        remarks: remarks[i],
                    }
                    newArr.push(obj)

                }
                this.setState({ tableArr: newArr })
            }
        }
        console.log(this.state.formData)
    }

    closeStageModal() {
        if (!this.state.isEditMode) {
            let {
                allocatedtoempnames, checkedbyempnames, allocatedtoempids, checkedbyempids,
                remarks, predefinedTat, predefinedTATStr, isPredefinedTATSelected, locationOnAction,
                dueDate, dueDateStr, isDueDateSelected
            } = this.state.formdata

            let currentStage = this.state.defaultStage

            let newDefaultStage = this.state.defaultStage - 1
            allocatedtoempnames[currentStage] = ''
            allocatedtoempids[currentStage] = '-1'
            checkedbyempids[currentStage] = '-1'
            checkedbyempnames[currentStage] = ''
            remarks[currentStage] = ''
            predefinedTat[currentStage] = '-1'
            predefinedTATStr[currentStage] = ''
            isPredefinedTATSelected[currentStage] = false
            locationOnAction[currentStage] = false
            dueDate[currentStage] = `${moment(new Date()).format('YYYY-MM-DD HH:mm:ss')}`
            dueDateStr[currentStage] = ''
            isDueDateSelected[currentStage] = false
            if (newDefaultStage == 0) {
                this.setState({ isMultipleStage: false })
            }
            this.setState({
                isAddStageModalOpen: false,
                renderAgain: true,
                defaultStage: newDefaultStage
            })
        } else {
            this.setState({ isAddStageModalOpen: false, isEditMode: false })
        }
    }
    storeRemarksValue(e) {
        if (!this.state.isEditMode) {
            let { remarks } = this.state.formdata
            remarks[this.state.defaultStage] = e.target.value
            this.setState({ renderAgain: true })
        } else {
            this.state.editRowData.remarks = e.target.value
            this.setState({ renderAgain: true })
        }
        // storeRemarksValue
    }

    CloseTATModal() {
        console.log("calerrhjfd")
    if (!this.state.isEditMode) {
        let { isPredefinedTATSelected } = this.state.formdata;
        isPredefinedTATSelected[this.state.defaultStage] = false;
        this.setState({
            isOpenTATmodal: false,
            renderAgain: true,
        });
    } else {
        this.state.editRowData.isPredefinedTATSelected = false;
        this.setState({
            isOpenTATmodal: false,
            renderAgain: true,
        });
    }
}

    OpenTATModal(e) {
        if (!this.state.isEditMode) {
            let { isPredefinedTATSelected, predefinedTat, predefinedTATStr } = this.state.formdata
            isPredefinedTATSelected[this.state.defaultStage] = e.target.checked
            this.setState({ renderAgain: true, isOpenTATmodal: e.target.checked })
            if (!e.target.checked) {
                predefinedTat[this.state.defaultStage] = '-1'
                predefinedTATStr[this.state.defaultStage] = ''
            }
        } else {
            this.state.editRowData.isPredefinedTATSelected = e.target.checked
            this.setState({ renderAgain: true, isOpenTATmodal: e.target.checked })
            if (!e.target.checked) {
                this.state.editRowData.predefinedTat = '-1'
                this.state.editRowData.predefinedTATStr = ''
            }
        }
    }
     ExportFile=async(e)=> {
        if(!this.props.userid) return;
        e.preventDefault()
// setisloading(true)
        const obj={
            query:`[dbo].[HRApp_Droid_Proc_AddTicket_Import_Template_getData] @UserID='{0}'`,
            queryArr:[`${this.props.userid}`]
        }

       Hexapi(obj)
       .then((resp) => {
            console.log(resp,"clg")
            // setisloading(false)
            function setDate(date) {
                var dateObj = TimeFormatter(date)
                var str = dateObj.userSplitedDate[2] + ' ' + dateObj.ShiftMonth + ' ' + dateObj.userSplitedDate[0]
                return str
            }


            var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0');
            var yyyy = today.getFullYear();
            var hrs = String(today.getHours()).padStart(2, '0')
            var mins = String(today.getMinutes()).padStart(2, '0')
            var newfilename = `trackhr_add_ticket_template_${yyyy}${mm}${dd}_${hrs}${mins}`
           console.log()
            var datakeys = Object.keys(resp)
            let tableObj = {},
                validations = {}
            for (const key in resp) {
                console.log(datakeys,"datakeys")
                var arr = []
                if (key != 'fileinfo') {
                    if (key == "validations") {
                        console.log('validationstest')
                        validations['validations'] = resp[key]
                        console.log(resp[key])
                    } else {
                        let data = resp[key]
                        console.log(data,"dataaaaaaaaaaa")
                        for (let i = 0; i < data.length; i++) {
                            let rowKeys = Object.keys(data[i])
                            let obj = {}
                            for (let j = 0; j < rowKeys.length; j++) {
                                if (data[i][rowKeys[j]] == "null") {
                                    data[i][rowKeys[j]] = ''
                                }
                                if (data[i][rowKeys[j]] != undefined && data[i][rowKeys[j]] != null && data[i][rowKeys[j]].date != undefined && data[i][rowKeys[j]].date != null) {
                                    obj[rowKeys[j]] = setDate(data[i][rowKeys[j]]['date'])
                                } else {
                                    obj[rowKeys[j]] = data[i][rowKeys[j]]
                                }
                            }
                            arr.push(obj)
                        }

                        tableObj[key] = arr
                    }

                }
            }


            if (document.getElementById('tabledata')) {
                document.getElementById('tabledata').value = JSON.stringify(tableObj)
                document.getElementById('filename').value = newfilename
                document.getElementById('validations').value = JSON.stringify(validations)

          if (tableObj && newfilename) {
        document.getElementById('ExcelExport').click();


        setTimeout(() => {
 this.setState({isOpenBulkUploadList:false})
        }, 1200);
      }}

        }).catch((error)=>{
           this.setState({isOpenBulkUploadList:false})
      if(error.message =="SQL Error occurred"){
           showCustomSwal("error occurred please try again")

         }

        }
    
    )
    }


  ImportFile = async (e) => {
     if(!this.props.userid) return;
  const fileObj = e.target.files[0];
  if (!fileObj) {
    return;
  }

  e.target.value = null;

  if (typeof ExcelRenderer !== "function") {

    return;
  }

  try {
    const data = await new Promise((resolve, reject) => {

      ExcelRenderer(fileObj, (err, resp) => {
        if (err) {
          console.error("ExcelRenderer failed:", err);
          reject(err);
          return;
        }
        console.log(" ExcelRenderer success:", resp);

        if (!resp.rows || resp.rows.length < 2) {
          console.error(" Excel file has no data");
          reject(new Error("Empty file"));
          return;
        }

        const headers = resp.rows[0];
        const result = [];

        for (let i = 1; i < resp.rows.length; i++) {
          const row = resp.rows[i];
          const obj = {};

          headers.forEach((key, j) => {
            let val = row[j] || "";
            if (key?.includes("(yyyy-MM-dd)")) {
              key = key.split("(yyyy-MM-dd)")[0];
              val = typeof val === "number" ? this.convertExcelDate(val) : val;
            }
            obj[key] = val;
          });

          result.push(obj);
        }

        resolve(result);
        this.setState({isOpenBulkUploadList:false})
      });
    });

    console.log("Parsed Excel result:", data);

    const json = JSON.stringify(data);
    const obj = {
      query: `[dbo].[HRApp_Droid_Proc_AddTicket_Import_Submit] @UserID='{0}', @Json='{1}'`,
      queryArr: [`${this.props.userid}`, json],
    };

    console.log(" Sending to Hexapi:", obj);

    if (typeof Hexapi !== "function") {
      console.error("Hexapi not defined");
      return;
    }

    const resp = await Hexapi(obj);
    console.log("Hexapi response:", resp);

    if (resp?.[""]?.[0]) {
        await showConfirm({
  content: resp[''][0].msg,
  hideCancel: true,
})

    } else {
        await showConfirm({
  content:"No response received from server",
  hideCancel: true,
})

    }

  } catch (err) {
    if(err.message =="SQL Error occurred"){
           showCustomSwal("error occurred please try again")

         }

  }
};


 convertExcelDate = (date) => {
  const jsDate = new Date(Math.round((date - 25569) * 864e5));
  return jsDate.toISOString().split("T")[0];
};

   openDueDateModal(e) {
        if (!this.state.isEditMode) {
            let { isDueDateSelected, dueDate, dueDateStr } = this.state.formdata
            isDueDateSelected[this.state.defaultStage] = e.target.checked
            this.setState({ renderAgain: true, isOpenDueDateModal: e.target.checked })
            if (!e.target.checked) {
                dueDate[this.state.defaultStage] = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                dueDateStr[this.state.defaultStage] = ''
            }
        } else {
            this.state.editRowData.isDueDateSelected = e.target.checked
            this.setState({ renderAgain: true, isOpenDueDateModal: e.target.checked })
            if (!e.target.checked) {
                this.state.editRowData.dueDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                this.state.editRowData.dueDateStr = ''
            }
        }
    }
    storeLocations(e) {
        if (!this.state.isEditMode) {
            let { locationOnAction } = this.state.formdata
            locationOnAction[this.state.defaultStage] = e.target.checked
            this.setState({ renderAgain: true })
        } else {
            this.state.editRowData.locationOnAction = e.target.checked
            this.setState({ renderAgain: true })
        }
    }
    storeAlerNow(e) {
        console.log(e.target.checked)
        this.setState({ alertNow:e.target.checked,renderAgain: true })
    }
    onAddStageSuccess() {
        if (!this.state.isEditMode) {
            console.log("hey calleddd")
            let {
                allocatedtoempnames, checkedbyempnames, allocatedtoempids, checkedbyempids,
                remarks, predefinedTat, predefinedTATStr, isPredefinedTATSelected, locationOnAction,
                dueDate, dueDateStr, isDueDateSelected
            } = this.state.formdata

            let isStageCanAdd = true
            if (checkedbyempnames[this.state.defaultStage] == "") {
                isStageCanAdd = false
                this.setState({ stageModalCheckedbylabelColor: 'red' })
            } else {
                this.setState({ stageModalCheckedbylabelColor: 'black' })
            }
            if (allocatedtoempnames[this.state.defaultStage] == "") {
                isStageCanAdd = false
                this.setState({ stageModalallocatedlabelColor: 'red' })
            } else {
                this.setState({ stageModalallocatedlabelColor: 'black' })
            }


            if (isStageCanAdd) {
                let newDefaultStage = this.state.defaultStage + 1
                let newArr = []
                for (let i = 0; i < newDefaultStage; i++) {
                    let obj = {
                        allocatedtoempname: allocatedtoempnames[i],
                        allocatedtoempid: allocatedtoempids[i],
                        checkedbyempname: checkedbyempnames[i],
                        checkedbyempid: checkedbyempids[i],
                        // stage: `Stage ${i + 1}/${newDefaultStage}`,
                        predefinedTATstr: predefinedTATStr[i],
                        remarks: remarks[i],
                        dueDateStr:dueDateStr[i]
                        // currentStage: i
                    }
                    newArr.push(obj)
                    // console.error('hello')
                }
                this.setState({
                    tableArr: newArr,
                    renderAgain: true,
                    isAddStageModalOpen: false,
                })
                this.scrollToMyRef();
            }
        } else {
            console.log("heyy here")
            let {
                allocatedtoempnames, checkedbyempnames, allocatedtoempids, checkedbyempids,
                remarks, predefinedTat, predefinedTATStr, isPredefinedTATSelected, locationOnAction,
                dueDate, dueDateStr, isDueDateSelected
            } = this.state.editRowData
            console.log(this.state.editRowData)
            let isStageCanAdd = true
            if (this.state.editRowData.checkedbyempnames == "") {
                isStageCanAdd = false
                this.setState({ stageModalCheckedbylabelColor: 'red' })
            } else {
                this.setState({ stageModalCheckedbylabelColor: 'black' })
            }

            if (isStageCanAdd) {
                let newDefaultStage = this.state.defaultStage + 1
                let obj = {}
                for (let i = 0; i < this.state.tableArr.length; i++) {
                    if (i == this.state.editRowId) {
                        obj = {
                            "allocatedtoempname": this.state.editRowData.allocatedtoempnames,
                            "allocatedtoempid": this.state.editRowData.allocatedtoempids,
                            "checkedbyempname": this.state.editRowData.checkedbyempnames,
                            "checkedbyempid": this.state.editRowData.checkedbyempids,
                            "predefinedTATstr": this.state.editRowData.predefinedTATStr,
                            "remarks": this.state.editRowData.remarks,
                            "dueDateStr":this.state.editRowData.dueDateStr
                        }
                    }
                }
                this.state.tableArr[this.state.editRowId] = obj

                this.state.formdata.allocatedtoempnames[this.state.editRowId] = allocatedtoempnames
                this.state.formdata.checkedbyempnames[this.state.editRowId] = checkedbyempnames
                this.state.formdata.allocatedtoempids[this.state.editRowId] = allocatedtoempids
                this.state.formdata.checkedbyempids[this.state.editRowId] = checkedbyempids
                this.state.formdata.remarks[this.state.editRowId] = remarks
                this.state.formdata.predefinedTat[this.state.editRowId] = predefinedTat
                this.state.formdata.predefinedTATStr[this.state.editRowId] = predefinedTATStr
                this.state.formdata.isPredefinedTATSelected[this.state.editRowId] = isPredefinedTATSelected
                this.state.formdata.locationOnAction[this.state.editRowId] = locationOnAction
                this.state.formdata.dueDate[this.state.editRowId] = dueDate
                this.state.formdata.dueDateStr[this.state.editRowId] = dueDateStr
                this.state.formdata.isDueDateSelected[this.state.editRowId] = isDueDateSelected

                this.setState({
                    isEditMode: false,
                    renderAgain: true,
                    isAddStageModalOpen: false,
                })
                this.scrollToMyRef();
            }
        }
        console.log(this.state.formdata)
    }

    removeTableRow(rowid) {
        console.log(rowid)
        var spliced = this.state.tableArr.splice(rowid, 1)
        this.setState({ defaultStage: this.state.defaultStage - 1 }, () => {
            let {
                allocatedtoempnames, checkedbyempnames, allocatedtoempids, checkedbyempids,
                remarks, predefinedTat, predefinedTATStr, isPredefinedTATSelected, locationOnAction,
                dueDate, dueDateStr, isDueDateSelected
            } = this.state.formdata

            allocatedtoempids.splice(rowid, 1)
            checkedbyempids.splice(rowid, 1)
            allocatedtoempnames.splice(rowid, 1)
            checkedbyempnames.splice(rowid, 1)
            remarks.splice(rowid, 1)
            predefinedTATStr.splice(rowid, 1)
            predefinedTat.splice(rowid, 1)
            isPredefinedTATSelected.splice(rowid, 1)
            locationOnAction.splice(rowid, 1)
            dueDate.splice(rowid, 1)
            dueDateStr.splice(rowid, 1)
            isDueDateSelected.splice(rowid, 1)

            this.setState({
                isAddStageModalOpen: false,
                renderAgain: true
            }, () => {
                if (this.state.defaultStage == 0) {
                    this.setState({ isEditMode: false, isMultipleStage: false, isParallel: false })
                }
            })
        })
    }
    render() {

        return (
            <div   style={{
    width: "100%",
    height: "calc(91vh - 10px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow:"hidden"

  }}>
                <div className='boxcss' style={{ height:"78vh", overflowY:"auto", scrollbarWidth:"none", overflowX:"hidden" }}>
                    <div className='container-fluid form_mainBox ' style={{ borderRadius:"10px", display: "block", backgroundColor: 'var(--smBox)' ,width:"900px"}}>
                        <div className="form_topRow p-2">
                            <div  className="row mb-1">
 <div className="col-md-2 col-2 form_categorypicadd" style={{border:this.state.categoryColor == 'red' ? "3px solid red" : ""}} onClick={() => this.setState({ isOpencategorymodal: true })}>
                                <Categorypic categoryID={(this.state.categoryIDSelected == '' ? '' : this.state.categoryIDSelected)} setcolrborder={()=>this.setState({categoryColor:""})}/>
                            </div>
                            <div className="col-md-8 col-8">
                                {/* <Inputbox
                                    wordboundation={{ limit: 150, id: 'descriptionInput' }}
                                    htmlFor={"Description"}
                                    label={"DESCRIPTION"}
                                    type="text"
                                    labelStyle={{ fontSize: "14px", fontWeight: "600", color: this.state.descriptionColor }}
                                    placeholder={`Enter description`}
                                    value={this.state.Description}
                                    onChange={(e) => this.setState({ Description: e.target.value, descriptionColor: 'black' })}
                                    required={true}
                                    fieldName="TicketDescription"
                                /> */}
                                <Textbox
                                                                            htmlFor={"description"}
                                                                            name="description"
                                                                            id="descriptionInput"
                                                                           
                                                                            required={true}
                                                                             value={this.state.Description}
                         htmlFor={"Description"}
                                    label={"DESCRIPTION"}
                                    type="text"
                                    labelStyle={{ fontSize: "14px", fontWeight: "600", color: this.state.descriptionColor }}
                                    placeholder={`Enter description`}
                                                                            readOnly={false}
                                                                            onChange={(e) => this.setState({ Description: e.target.value, descriptionColor: 'black' })}
                                                                            wordboundation={{ limit: 150, id: 'descriptionInput' }}
                                                                            fieldName="TicketDescription"
                                                                        // textstyle={{backgroundColor:"#f2f2f2" , padding:"4px" , borderRadius:"2px", marginTop:"10px"}}
                                                                        />
                            </div>
                            <div className="col-md-2 setdone">
                                <span  id="saveBtnadd" onClick={(e) => {
                                    localStorage.setItem("refresh", "true");
                                    this.Addticket(e)
                                }}>SAVE</span>
<button type="button" className='bulkuploadBtnadd' style={{ zIndex: 10}} onClick={() => {this.setState({ isOpenBulkUploadList: true })}}>
  <UploadIcon /> Bulk Upload
</button>
                            </div>

   
<div>
                            </div>


</div>
                        </div>

                        <div className="FirstStageDiv" style={{ display: this.state.isMultipleStage ? "none" : 'block' }}>
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <Inputbox
                                        htmlFor={"ALLOCATED"}
                                        label={"ALLOCATED TO"}
                                        type="text"
                                        labelStyle={{ fontSize: "14px", fontWeight: "600", color: this.state.allocatedToEmpLabelColor }}
                                        placeholder={`Select Allocated to`}
                                        value={this.state.formdata.allocatedtoempnames[0]}
                                        onClick={() => this.setState({ isOpenAllocatedempmodal: true })}
                                        readOnly={true}
                                        required={true}
                                          fieldName="TicketAllocatedTo"
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <Inputbox
                                        htmlFor={"CHECKED"}
                                        label={"CHECKED BY"}
                                        type="text"
                                        labelStyle={{ fontSize: "14px", fontWeight: "600", color: this.state.checkedByEmpLabelColor }}
                                        placeholder={`Select Checked By`}
                                        value={this.state.formdata.checkedbyempnames[0]}
                                        onClick={() => this.setState({ isOpenCheckedempmodal: true })}
                                        readOnly={true}
                                        required={true}
                                        fieldName="TicketCheckedBy"
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <Inputbox
                                        wordboundation={{ limit: 150, id: 'remarksInput' }}
                                        htmlFor={"REMARKS"}
                                        label={"REMARKS"}
                                        value={this.state.formdata.remarks[0]}
                                        onChange={(e) => this.storeRemarksValue(e)}
                                        type="text"
                                        labelStyle={{ fontSize: "14px", fontWeight: "600", color: "black" }}
                                        placeholder={`Enter value`}
                                        required={false}
                                        fieldName="TicketRemarks"
                                    />
                                </div>
                            </div>
                          <div className="tatmodal">
                                <div className="row">

                                        <div className="col-6">
                                                                      <Tatdate
                                    label='PREDEFINED TAT'
                                    fieldName="TicketPredefinedTAT"
  isChecked={this.state.formdata.isPredefinedTATSelected[0]}
  onSwitchChange={(e) => this.OpenTATModal(e)}
  inputValue={this.state.formdata.predefinedTATStr[0]}
  onInputClick={() => this.setState({ isOpenTATmodal: true })}
/>

                                        </div>
                                        <div className="col-6">
                                                                      <Tatdate
                                    label='Due Date'
                                    fieldName={"TicketDueDate"}
  isChecked={this.state.formdata.isDueDateSelected[0]}
  onSwitchChange={(e) => this.openDueDateModal(e)}
  inputValue={this.state.formdata.dueDateStr[0]}
  onInputClick={() => this.setState({ isOpenDueDateModal: true })}
/>

                                        </div>

                                </div>
                            </div>
                            <div className="locationmodal">
                                <div className="row">
                                    <div className="col-md-6 col-6">
                                                                           <Tatdate
                                    label='LOCATIONS ON ACTIONS'
                                    fieldName={"TicketLocationsOnActions"}
  isChecked={this.state.formdata.locationOnAction[0]}
  onSwitchChange={(e) => this.storeLocations(e)}
  showInput={false}

/>
                                    </div>
                                     <div className="col-md-6 col-6">                                               <Tatdate
                                    label='ALERT NOW'
                                    fieldName={"TicketAlertNow"}
  isChecked={this.state.alertNow}
  onSwitchChange={(e) => this.storeAlerNow(e)}
  showInput={false}
/>
                                    </div>
                                </div>
                            </div>


                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <div className=' d-flex align-items-center gap-2'>
                                    <label htmlFor="Observers" style={{ fontWeight: '600', fontSize: '14px',marginTop:"4px" }}>OBSERVERS</label>
                                  <p style={{marginBottom:"2px"}}>
                                      <TooltipButton fieldName="TicketObserver"/>
                                  </p>
                                    </div>
                                    <Textbox
                                        name="Observers"
                                        id="Observers"
                                        placeholder='Select observers'
                                        required={true}
                                        value={this.state.observerEmpnamelist}
                                        onClick={(e) => this.setState({isobserverModal:true})}
                                        readOnly={true}
                                    />
                                    
                                </div>
                            </div>
                        </div>

{
    this.state.isobserverModal && <Empmodalbody
            show={this.state.isobserverModal}
            hide={() => this.setState({isobserverModal:false})}
            isMultiple={true}
            empids={this.state.observerEmpIdslist}
            empnames={this.state.observerEmpnamelist}
            managers={this.state.observerEmplist}
            heading={"Observers"}
            onChange={(ids, names) =>
              this.selectedEmployees(ids, names)
            }
          />
}
{
  !this.state.isMultipleStage && <div className="Addstage" style={{paddingLeft:"15px"}} onClick={(e) => this.AddStages(e)}>
                            <span style={{fontSize:"14px"}}>Add Stage</span>
                        </div>  
}
                          
                        <div className="newStageDiv" style={{ display: this.state.isMultipleStage ? "block" : 'none' }}>
                            <div className="sequential_parallel_div">
                                <span>Sequential</span>
                                <Switch
                                    color="primary"
                                    checked={this.state.isParallel}
                                    onChange={(e) => this.setState({ isParallel: e.target.checked })}
                                />
                                <span className='parallel'>Parallel</span>
                            </div>
                            <div className="alertnowmodal">
                                <div className="row">
                                    <div className="col-md-12 col-12">
                                        <div className="row">
                                            <div className="col-md-2 col-5" style={{ padding: "0px" }}>
                                                <p style={{fontSize:"14px"}}>ALERT NOW</p>
                                            </div>
                                            <div className="col-md-10 col-5" style={{ marginTop: "-4px", padding: "0px" }}>
                                                <Switch
                                                    color="primary"
                                                    checked={this.state.alertNow}
                                                    onChange={(e) => this.storeAlerNow(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <label htmlFor="Observers" style={{ fontWeight: '600', fontSize: '14px' }}>OBSERVERS <span style={{ color: 'red', fontSize: "14px" }}>*</span> </label>
                                    <Textbox
                                        name="Observers"
                                        id="Observers"
                                        placeholder='Select observers'
                                        required={true}
                                        value={this.state.observerEmpnamelist}
                                        onClick={(e) => this.setState({isobserverModal:true})}
                                        readOnly={true}
                                    />
                                </div>
                            </div>
                            <div className="Addstage" style={{paddingLeft:"15px"}} onClick={(e) => this.AddStages(e)}>
                            <span style={{fontSize:"14px"}}>Add Stage</span>
                        </div> 
                            <Table responsive id="myReportTable">
                                <thead>
                                    <tr style={{ background: "var(--Primary)", border: "none", color: "white", position: "sticky", top: "0px", zIndex: '1' }}>
                                        {this.getHeader(this.state.stageheaders)}
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.tableArr.map((data, i) => {
                                            return (
                                                <tr onClick={() => this.onEditRow(i)} className="maintablerow">
                                                    <td>
                                                        <div className="tablebox stage">
                                                            Stage {i + 1}/{this.state.tableArr.length}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="photoTablecolumn">
                                                            {
                                                                i != 0 ?
                                                                    <span className='topsmallbar'></span>
                                                                    : null
                                                            }
                                                            <div style={{marginRight:"4px"}}><GetImage width={"20px"} height={"20px"} imgID={data.allocatedtoempid} getPhotoUrl={this.state.getPhotoUrl} /></div>
                                                            <span>{data.allocatedtoempname}</span>
                                                            {
                                                                i != this.state.tableArr.length - 1 ?
                                                                    <span className='bottomsmallbar'></span>
                                                                    : null
                                                            }
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="photoTablecolumn">
                                                            <div style={{marginRight:"4px"}}><GetImage width={"20px"} height={"20px"} imgID={data.checkedbyempid} getPhotoUrl={this.state.getPhotoUrl} /></div>
                                                            <span>{data.checkedbyempname}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tablebox">
                                                            {data.predefinedTATstr}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tablebox">
                                                            <span className='remarks'>{data.remarks}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tablebox">
                                                            <span className='remarks'>{data.dueDateStr}</span>
                                                        </div>
                                                    </td>
                                                    <td>

                                                        <div className="tablebox">
                                                            <IconButton onClick={() => this.removeTableRow(i)}>
                                                                <CloseIcon />
                                                            </IconButton>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>
                        </div>

                       
                    </div>
                </div>

                <Modal centered size="sm" id="loadingModal" animation={true} show={!this.state.isloadcompleted} onHide={() => this.setState({ isloadcompleted: true })} style={{ backgroundColor: 'rgba(0,0,0,0.6)' }} backdrop="static" keyboard={false} > {/* backdrop="static" keyboard={false} */}
                    <Modal.Body style={{ height: 'auto' }}>
                        <div style={{ display: 'flex', alignItems: 'center', padding: "8px", paddingBottom: "16px" }}>
                            
                             <Loader/>
                            <span style={{ paddingLeft: "20px" }}>Loading...</span>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal id="contaxtModal" style={{backdropFilter:"blur(6px)"}} size={"sm"} centered show={this.state.isOpenBulkUploadList} onHide={() => this.setState({ isOpenBulkUploadList: false })}>
                    <Modal.Body>

                        <div style={{ borderTop: '', display: "flex", justifyContent: "space-between" }} className='customContaxtMenu' onClick={(e) => this.ExportFile(e)}>
                            <div style={{ display: "flex" }}>
                                <div style={{ paddingRight: "10px" }}>
                                    <DownloadIcon />
                                </div>
                                <span>Download Template</span>
                            </div>
                        </div>
                        <div style={{ borderTop: '1px solid rgba(0,0,0,0.1)', display: "flex", justifyContent: "space-between" }} className='customContaxtMenu'>
                            <div style={{ display: "flex" , cursor:"pointer"}} >
                                <div style={{ paddingRight: "10px" }}>
                                    <UploadIcon  />
                                </div>

                                <input style={{ display: "flex" , cursor:"pointer"}} type="file" hidden id="excelfile" onChange={(e) => this.ImportFile(e)} />
                                <label  htmlFor="excelfile" style={{cursor:"pointer", width: "250px" }}>
                                    <span >Upload Data</span>
                                </label>
                            </div>
                        </div>

                        <form action={this.state.excelDownloadUrl} method="POST" style={{ display: "none" }}>
                            <input type="hidden" id='tabledata' name='tabledata' />
                            <input type="hidden" id='filename' name='filename' />
                            <input type="hidden" id='validations' name='validations' />
                            <button type="submit" id='ExcelExport' />
                        </form>
                    </Modal.Body>
                </Modal>
                {
                    this.state.isEditMode ?
                        <Modal centered size="sm" animation={true} show={this.state.isAddStageModalOpen} onHide={() => this.setState({ isAddStageModalOpen: false })} style={{ backgroundColor: 'rgba(0,0,0,0.6)' }} backdrop="static" keyboard={false}> {/* backdrop="static" keyboard={false} */}
                            <Modal.Body style={{ height: 'auto' }}>
                                <div>
                                    <div className="Stageheader">
                                        <p>Stage {this.state.editRowId + 1}/{this.state.defaultStage + 1}</p>
                                        <IconButton onClick={() => this.closeEditModal()}>
                                            <CloseIcon />
                                        </IconButton>
                                    </div>
                                    <Inputbox
                                        htmlFor={"ALLOCATED"}
                                        label={"ALLOCATED TO"}
                                        type="text"
                                        labelStyle={{ fontSize: "14px", fontWeight: "600", color: this.state.stageModalallocatedlabelColor }}
                                        placeholder={`Select Allocated to`}
                                        value={this.state.editRowData.allocatedtoempnames}
                                        onClick={() => this.setState({ isOpenAllocatedempmodal: true })}
                                        readOnly={true}
                                        required={true}
                                    />
                                    <div style={{ marginBottom: "10px" }}></div>
                                    <Inputbox
                                        htmlFor={"CHECKED"}
                                        label={"CHECKED BY"}
                                        type="text"
                                        labelStyle={{ fontSize: "14px", fontWeight: "600", color: this.state.stageModalCheckedbylabelColor }}
                                        placeholder={`Select Checked By`}
                                        value={this.state.editRowData.checkedbyempnames}
                                        onClick={() => this.setState({ isOpenCheckedempmodal: true })}
                                        readOnly={true}
                                        required={true}
                                    />
                                    <div style={{ marginBottom: "10px" }}></div>
                                    <Inputbox
                                        wordboundation={{ limit: 150, id: `remarks${this.state.defaultStage}Input` }}
                                        htmlFor={"REMARKS"}
                                        label={"REMARKS"}
                                        value={this.state.editRowData.remarks}
                                        onChange={(e) => this.storeRemarksValue(e)}
                                        type="text"
                                        labelStyle={{ fontSize: "14px", fontWeight: "600", color: "black" }}
                                        placeholder={`Enter value`}
                                        required={false}
                                    />
                                      <div className="predefinedTAT">

                                                                <Tatdate
                                                                iscol={true}
                                    label='PREDEFINED TAT'
                                    fieldName="TicketPredefinedTAT"
  isChecked={this.state.editRowData.isPredefinedTATSelected}
  onSwitchChange={(e) => this.OpenTATModal(e)}
  isdiff={true}
  inputValue={this.state.editRowData.predefinedTATStr}
  onInputClick={() => this.setState({ isOpenTATmodal: true })}
/>


                                    </div>

                                      <div style={{ marginBottom: "10px" }}></div>

                                       <div className="predefinedTATt">
                                                                     <Tatdate
                                                                      iscol={true}
                                    label='LOCATIONS ON ACTIONS'
                                    fieldName={"TicketLocationsOnActions"}
  isChecked={this.state.editRowData.locationOnAction}
  onSwitchChange={(e) => this.storeLocations(e)}
  showInput={false}
  isdiff={true}

/>
</div>

                                             <div className="predefinedTATt">
                                                                      <Tatdate
                                                                       iscol={true}
                                    label='DUE DATE'
                                    fieldName={"TicketDueDate"}
  isChecked={this.state.editRowData.isDueDateSelected}
  onSwitchChange={(e) => this.openDueDateModal(e)}
  isdiff={true}
  inputValue={this.state.editRowData.dueDateStr}
  onInputClick={() => this.setState({ isOpenDueDateModal: true })}
/>
</div>


                                    <div className="StageOKbtn">
                                        <span onClick={() => this.onAddStageSuccess()}>OK</span>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                        :
                        <Modal centered size="sm" animation={true} show={this.state.isAddStageModalOpen} onHide={() => this.setState({ isAddStageModalOpen: false })} style={{ backgroundColor: 'rgba(0,0,0,0.6)' }} backdrop="static" keyboard={false}> {/* backdrop="static" keyboard={false} */}
                            <Modal.Body style={{ height: 'auto' }}>
                                <div>
                                    <div className="Stageheader">
                                        <p>Stage {this.state.defaultStage + 1}/{this.state.defaultStage + 1}</p>
                                        <IconButton onClick={() => this.closeStageModal()}>
                                            <CloseIcon />
                                        </IconButton>
                                    </div>
                                    <Inputbox
                                        htmlFor={"ALLOCATED"}
                                        label={"ALLOCATED TO"}
                                        type="text"
                                        labelStyle={{ fontSize: "14px", fontWeight: "600", color: this.state.stageModalallocatedlabelColor }}
                                        placeholder={`Select Allocated to`}
                                        value={this.state.formdata.allocatedtoempnames[this.state.defaultStage]}
                                        onClick={() => this.setState({ isOpenAllocatedempmodal: true })}
                                        readOnly={true}
                                        required={true}
                                    />

                                    <Inputbox
                                        htmlFor={"CHECKED"}
                                        label={"CHECKED BY"}
                                        type="text"
                                        labelStyle={{ fontSize: "14px", fontWeight: "600", color: this.state.stageModalCheckedbylabelColor }}
                                        placeholder={`Select Checked By`}
                                        value={this.state.formdata.checkedbyempnames[this.state.defaultStage]}
                                        onClick={() => this.setState({ isOpenCheckedempmodal: true })}
                                        readOnly={true}
                                        required={true}
                                    />
                                    <div style={{ marginBottom: "10px" }}></div>
                                    <Inputbox
                                        wordboundation={{ limit: 150, id: `remarks${this.state.defaultStage}Input` }}
                                        htmlFor={"REMARKS"}
                                        label={"REMARKS"}
                                        value={this.state.formdata.remarks[this.state.defaultStage]}
                                        onChange={(e) => this.storeRemarksValue(e)}
                                        type="text"
                                        labelStyle={{ fontSize: "14px", fontWeight: "600", color: "black" }}
                                        placeholder={`Enter value`}
                                        required={false}
                                    />



                                    <div className="predefinedTATt">

                                        <Tatdate
                                         iscol={true}
                                    label='PREDEFINED TAT'
                                    fieldName="TicketPredefinedTAT"
  isChecked={this.state.formdata.isPredefinedTATSelected[this.state.defaultStage]}
  onSwitchChange={(e) => this.OpenTATModal(e)}
  isdiff={true}
  inputValue={this.state.formdata.predefinedTATStr[this.state.defaultStage]}
  onInputClick={() => this.setState({ isOpenTATmodal: true })}
/>

                                    </div>
                                    <div style={{ marginBottom: "10px" }}></div>

                                       <div className="predefinedTATt">
                                                                     <Tatdate
 iscol={true}
                                    label='LOCATIONS ON ACTIONS'
                                    fieldName={"TicketLocationsOnActions"}
  isChecked={this.state.formdata.locationOnAction[this.state.defaultStage]}
  onSwitchChange={(e) => this.storeLocations(e)}
  showInput={false}
  isdiff={true}
/>
</div>

                                             <div className="predefinedTATt">
                                                                      <Tatdate
                                                                       iscol={true}
                                    label='DUE DATE'
                                    fieldName={"TicketDueDate"}
  isChecked={this.state.formdata.isDueDateSelected[this.state.defaultStage]}
  onSwitchChange={(e) => this.openDueDateModal(e)}
  isdiff={true}
  inputValue={this.state.formdata.dueDateStr[this.state.defaultStage]}
  onInputClick={() => this.setState({ isOpenDueDateModal: true })}
/>
</div>
                                    <div className="StageOKbtn">
                                        <span onClick={() => this.onAddStageSuccess()}>OK</span>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                }
                <Modal style={{backdropFilter:"blur(6px)"}} centered onEntered={() => this.setState({ setFocus: true })} show={this.state.isOpencategorymodal} onHide={() => this.setState({ isOpencategorymodal: false })} backdrop="static" keyboard={false}>

                    <Modal.Body style={{paddingTop:"0px",overflow:"hidden"}}>
                        <MyModalBody onclose={()=>this.setState({ isOpencategorymodal: false })} setFocus={this.state.setFocus} callback={this.getCategoryID.bind(this)} />
                    </Modal.Body>
                </Modal>
{
    this.state.isOpenAllocatedempmodal && ( <Empmodal selecttext="Select Employee" onChange={this.getAllocuserid.bind(this)} show={this.state.isOpenAllocatedempmodal} handleclose={() => this.setState({ isOpenAllocatedempmodal: false })} data={this.state.AllocatedToEmpList} />
)
}

{
    this.state.isOpenCheckedempmodal && <Empmodal selecttext="Select Employee" onChange={this.getCheckuserid.bind(this)} show={this.state.isOpenCheckedempmodal} handleclose={() => this.setState({ isOpenCheckedempmodal: false })} data={this.state.CheckedByEmpList} />
}
<Modal className="DateModalBody" centered style={{ borderRadius:"0px", backgroundColor: 'rgba(0,0,0,0.6)' }} show={this.state.isOpenDueDateModal}>
                                        <Modal.Body>
                                           <DatePicker
                    openDatePicker={this.state.isOpenDueDateModal}
                    onHideDatePicker={() => this.setState({ isOpenDueDateModal: false })}
                    onChange={(date) => this.getDueDate(date)}
                    defaults={this.state.formdata.dueDate[this.state.defaultStage]}
                    disablePast={true}
                />
                                        </Modal.Body>
                                    </Modal>
  
                <Modal style={{ backgroundColor: 'rgba(0,0,0,0.6)' }} show={this.state.isOpenTATmodal} centered onHide={() =>
{
    this.CloseTATModal()
this.setState({ isOpenTATmodal: !this.state.isOpenTATmodal })}
}
                     backdrop="static" keyboard={false}>
                    <Modal.Header style={{display:"flex"  , padding:"10px", justifyContent:"space-between", alignContent:"center"}}>
                    <p style={{ fontSize: "18px", color: "#0cc1e6", marginBottom: "0px" }}>Select TAT</p>
                    <IoCloseOutline style={{ fontSize:"24px",cursor:"pointer" , color:"gray"}} onClick={()=>{
this.setState({isOpenTATmodal:false})
this.CloseTATModal()

                        }} />
                        
                    </Modal.Header>
                    <Modal.Body style={{ height: "160px" }}>
                        <TATModalBody callback={(tat, str) => this.getTATvalue(tat, str)} defaults={this.state.formdata.predefinedTat[this.state.defaultStage]} />
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}

export default withRouter(Addticket)